import React, { useEffect, useState } from 'react';
import { DEFAULT_PAGE_SIZE, MAX_PAGE_LINK_DISPLAY, ORDER_BY } from '@app/constants/Common';
import * as UserService from '@app/services/UserService';

const AccessLogHistory = () => {
    const [accessLogHistories, setAccessLogHistories] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [numberPages, setNumberPages] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [orderBy, setOrderBy] = useState(ORDER_BY.DESC_UPDATE_DATE);
    const [displayPages, setDisplayPages] = useState([]);

    const setDisplayPageLink = (totalNumber) => {
        let numberPageCount = Math.floor(Number(totalNumber) / DEFAULT_PAGE_SIZE) + 1
        setNumberPages(numberPageCount);
        // let tempDisplayPageList = []
        // if (numberPageCount > MAX_PAGE_LINK_DISPLAY) {
        //     let rightCount = numberPageCount - currentPage
        //     if (rightCount > Math.floor(MAX_PAGE_LINK_DISPLAY / 2)) {
        //         rightCount = Math.floor(MAX_PAGE_LINK_DISPLAY / 2)
        //     }
        //     let rightEndIndex = currentPage + rightCount
        //     let leftCount = MAX_PAGE_LINK_DISPLAY - rightCount - 1
        //     let leftStartIndex = currentPage - leftCount
        //     if (leftStartIndex < 0) {
        //         leftStartIndex = 0
        //     }
        //     for (let i = leftStartIndex; i < rightEndIndex; i++) {
        //         tempDisplayPageList.push(i);
        //     }
        // } else {
        //     for (let i = 0; i < numberPageCount; i++) {
        //         tempDisplayPageList.push(i);
        //     }
        // }

        // console.log(`Display List ${JSON.stringify(tempDisplayPageList)}`)

        // setDisplayPages(tempDisplayPageList)
    }

    const searchAccessLogHistories = (page, newOrderBy, searchConditions) => {
        setCurrentPage(page);
        setIsLoading(true)
        UserService.requestAccessHistories({ page: page, size: DEFAULT_PAGE_SIZE, order_by: newOrderBy }).then((res) => {
            console.log(`Response-CandidateList:${JSON.stringify(res)}`);
            setAccessLogHistories(res.content.access_logs);
            let totalNumber = res.content.totalCount ? Number(res.content.totalCount) : 0
            setTotalCount(totalNumber)
            setNumberPages(Math.floor(totalNumber / DEFAULT_PAGE_SIZE) + 1);
            if (currentPage === displayPages[0] || currentPage === displayPages[displayPages.length - 1]) {
                setDisplayPageLink(totalNumber)
            }
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
            setAccessLogHistories([]);
            setTotalCount(0)
            setNumberPages(0);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const nextPage = () => {
        let currPage = currentPage + 1
        if (currPage <= numberPages) {
            searchAccessLogHistories(currPage, orderBy)
        } else {
            currPage = numberPages
        }
        // setCurrentPage(currPage)
    };

    const backPage = () => {
        let currPage = currentPage - 1
        if (currPage > 0) {
            searchAccessLogHistories(currPage, orderBy)
        } else {
            currPage = 0
        }
        // setCurrentPage(currPage)
    };

    const gotoPage = (targetPage) => {
        setCurrentPage(targetPage);
        searchAccessLogHistories(targetPage, orderBy)
    };

    const onChangeOrderBy = (event) => {
        setOrderBy(event.target.value)
        searchAccessLogHistories(currentPage, event.target.value)
    }

    useEffect(async () => {
        searchAccessLogHistories(currentPage, orderBy)
    }, []);

    return (
        <div className='container-fluid'>
            <div className='card card-primary'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Quản lý truy cập</h3>
                </div>
                <div className='card-body'>
                    <div className='card card-default'>
                        <div className='card-header'>
                            <h3 className='card-title text-bold'>Lịch sử truy cập ({totalCount})</h3>
                            <div className='card-tools'>
                                {numberPages > 1 &&
                                    <ul className='pagination pagination-sm float-right mt-2'>
                                        <li className='page-item'>
                                            <button className='page-link' type={'button'}
                                                onClick={() => backPage()}>&laquo;</button>
                                        </li>
                                        {/*{displayPages.map((page) => {*/}
                                        {/*    if (currentPage === (page + 1)) {*/}
                                        {/*        return <li className='page-item' key={`top-page-link-${page}`}>*/}
                                        {/*            <button className='page-link bg-blue' type={'button'}*/}
                                        {/*                    onClick={() => gotoPage(page + 1)}>{page + 1}</button>*/}
                                        {/*        </li>*/}
                                        {/*    }*/}
                                        {/*    return <li className='page-item' key={`page_${page}`}>*/}
                                        {/*        <button className='page-link' type={'button'}*/}
                                        {/*                onClick={() => gotoPage(page + 1)}>{page + 1}</button>*/}
                                        {/*    </li>*/}
                                        {/*})}*/}
                                        <li className='page-item'>
                                            <button className='page-link' type={'button'}
                                                onClick={() => nextPage()}>&raquo;</button>
                                        </li>
                                    </ul>
                                }
                            </div>
                            {isLoading &&
                                <div className={'col-sm-12 text-center'}>
                                    <div className='spinner-grow text-primary' role='status'>
                                        <span className='sr-only'>Loading...</span>
                                    </div>
                                </div>}
                        </div>
                        <div className='card-body table-responsive p-0'>
                            <table
                                className='table table-hover table-bordered text-nowrap text-center'
                            // style={{maxHeight: '80vh', overflow: 'scroll'}}
                            >
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>User thực hiện</th>
                                        <th>Tên chức năng</th>
                                        <th>Thời gian truy cập</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {accessLogHistories && accessLogHistories.length > 0 && accessLogHistories.map((item, index) => (
                                        <tr key={`access_log_${index}`}>
                                            <td>{index + 1}</td>
                                            <td>{item.user_name}</td>
                                            <td>{item.function_name}</td>
                                            <td>{item.access_date_time}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className='card-footer'>
                            <div className='card-tools'>
                                {numberPages > 1 &&
                                    <ul className='pagination pagination-sm float-right'>
                                        <li className='page-item'>
                                            <button className='page-link' type={'button'}
                                                onClick={() => backPage()}>&laquo;</button>
                                        </li>
                                        {/*{displayPages.map((page) => {*/}
                                        {/*    if (currentPage === (page + 1)) {*/}
                                        {/*        return <li className='page-item' key={`footer-page-link-${page}`}>*/}
                                        {/*            <button className='page-link bg-blue' type={'button'}*/}
                                        {/*                    onClick={() => gotoPage(page + 1)}>{page + 1}</button>*/}
                                        {/*        </li>*/}
                                        {/*    }*/}
                                        {/*    return <li className='page-item' key={`page_${page}`}>*/}
                                        {/*        <button className='page-link' type={'button'}*/}
                                        {/*                onClick={() => gotoPage(page + 1)}>{page + 1}</button>*/}
                                        {/*    </li>*/}
                                        {/*})}*/}
                                        <li className='page-item'>
                                            <button className='page-link' type={'button'}
                                                onClick={() => nextPage()}>&raquo;</button>
                                        </li>
                                    </ul>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default AccessLogHistory;
